import marketTestPlans from "./marketTestPlans";
import marketTests from "./marketTests";

const marketTestService = [
    {
        matcher: 'marketTest/marketTestPlans',
        reply: config => {
            return [200, marketTestPlans];
        }
    },
    {
        matcher: /marketTest\/marketTestPlans\/(.*)/,
        reply: config => {
            const uuid = /marketTest\/marketTestPlans\/(.*)/.exec(config.url)[1];
            const marketTestPlan = marketTestPlans.find(marketTestPlan => marketTestPlan.uuid === uuid);
            return [200, marketTestPlan];
        }
    },
    {
        matcher: 'marketTest/marketTests',
        reply: config => {
            return [200, marketTests];
        }
    },
    {
        matcher: /marketTest\/marketTests\/(.*)/,
        reply: config => {
            const uuid = /marketTest\/marketTests\/(.*)/.exec(config.url)[1];
            const marketTest = marketTests.find(marketTest => marketTest.uuid === uuid);
            return [200, marketTest];
        }
    },
]

export default marketTestService;